import { CalendarInsertTimeDialogModule } from './calendar-insert-time-dialog/calendar-insert-time-dialog.module';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { FeedRoutingModule } from './feed-routing.module';
import { FeedComponent } from './feed.component';
import { GroupByKeyPipe } from './pipes/groupByKey.pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CustomDirectivesModule } from '@app/_directives/custom-directives.module';
import { UserAvatarModule } from '@app/shared/user-avatar/user-avatar.module';
import { UserMenuModule } from '@app/shared/user-menu/user-menu.module';
import { FabricFileIconModule } from '@app/modules/fabric/fabric-file-icon/fabric-file-icon.module';
import { FabricBaseIconModule } from '@app/modules/fabric/fabric-base-icon/fabric-base-icon.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { EstimationStatisticsGraphModule } from '@app/shared/estimation-statistics-graph/estimation-statistics-graph.module';
import { FeedFilterEventItemComponent } from './feed-filter-event-item/feed-filter-event-item.component';
import { DateFnsModule } from 'ngx-date-fns';
import { ParseCustomScopePipe } from './pipes/parse-custom-scope.pipe';
import { FixedGroupHeaderDirective } from './fixed-group-header.directive';
import { NgxScrollspyModule } from '@uniprank/ngx-scrollspy';
import { FixedGroupHeaderService } from './fixed-group-header.service';
import { TimeTrackerCalendarStepperCreateDialogModule } from '@app/shared/time-tracker-calendar-stepper-create-dialog/time-tracker-calendar-stepper-create-dialog.module';
import { ShellMenuToggleModule } from '@app/components/shell-menu-toggle/shell-menu-toggle.module';
import { TimeRangePickerModule } from '@app/shared/time-range-picker/time-range-picker.module';
import { DayPickerPopoverModule } from '@app/components/day-picker-popover/day-picker-popover.module';
import { FeedHiddenItemsDialogModule } from '@app/components/feed-hidden-items-dialog/feed-hidden-items-dialog.module';
import { ParseFeedDescriptionModule } from './pipes/parse-feed-description.module';
import { FeedPageService } from './feed.service';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FeedRoutingModule,
    CustomDirectivesModule,
    MaterialModule,
    TranslateModule,
    FlexLayoutModule,
    UserMenuModule,
    InfiniteScrollModule,
    UserAvatarModule,
    TimeTrackerCalendarStepperCreateDialogModule,
    CalendarInsertTimeDialogModule,
    FabricBaseIconModule,
    FabricFileIconModule,
    ScrollingModule,
    DateFnsModule,
    NgxScrollspyModule,
    EstimationStatisticsGraphModule,
    ShellMenuToggleModule,
    TimeRangePickerModule,
    DayPickerPopoverModule,
    FeedHiddenItemsDialogModule,
    ParseFeedDescriptionModule,
  ],
  declarations: [
    FeedComponent,
    GroupByKeyPipe,
    FeedFilterEventItemComponent,
    ParseCustomScopePipe,
    FixedGroupHeaderDirective,
  ],
  providers: [FixedGroupHeaderService],
})
export class FeedModule {
  /**
   * allows saving state without refetching on page load
   */
  static forRoot(): ModuleWithProviders<FeedModule> {
    return {
      ngModule: FeedModule,
      providers: [FeedPageService],
    };
  }
}
